var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3VoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 147,
    viewBox: "0 0 188 147",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.749023C53.3243 39.7393 118.227 63.1127 188 64.4281C150.181 84.3066 108.291 96.9994 63.9833 100.787L0 0.749023Z",
    fill: "url(#paint0_linear_1290_8388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4915 107.837L93.5212 146.971L131.385 95.3597C110.87 101.425 89.8201 105.545 68.4915 107.837Z",
    fill: "url(#paint1_linear_1290_8388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.833 55.2205L187.042 19.4956L187.013 19.4927C166.603 31.4509 144.882 41.2647 122.13 48.6412C134.866 51.6268 147.788 53.83 160.833 55.2205Z",
    fill: "url(#paint2_linear_1290_8388)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_8388",
    x1: -0.174924,
    y1: 36.1887,
    x2: 138.636,
    y2: 169.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F717FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EE2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1290_8388",
    x1: -0.174924,
    y1: 36.1887,
    x2: 138.636,
    y2: 169.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F717FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EE2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1290_8388",
    x1: -0.174924,
    y1: 36.1887,
    x2: 138.636,
    y2: 169.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F717FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EE2FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3VoLogo);
export default __webpack_public_path__ + "static/media/3voLogo.3c9f74c06d0e58790506648b3eb65079.svg";
export { ForwardRef as ReactComponent };